module.exports = __webpack_public_path__ + "img/date-and-time.9255ee3d.svg";